import { AjaxRequestPublisher } from 'src/commons/utils/metrics';
import { REQUEST_TIMEOUT } from './constants';
import logError from './log-error';
import composeMetricSlug from './compose-metric-slug';

type RequestInitOverride = Omit<RequestInit, 'body'> & {
  body?: any;
};

const fetchRequest = async (
  url: string,
  optionsOverride?: RequestInitOverride,
): Promise<Response> => {
  const startTime = performance.now();
  const abortController = new AbortController();
  const options: RequestInit = {
    method: 'GET',
    credentials: 'include',
    ...optionsOverride,
    signal: abortController.signal,
  };

  if (optionsOverride?.body) {
    options.body = JSON.stringify(optionsOverride.body);
  }

  const { sanitizedUrl, metricSlug, successMetricSlug } = composeMetricSlug({
    endpoint: url,
    method: options.method || 'GET',
  });
  const timeoutId = setTimeout(() => abortController.abort(), REQUEST_TIMEOUT);
  try {
    const response = await fetch(url, options);
    AjaxRequestPublisher.publishCounterMonitor(successMetricSlug, 1);
    return response;
  } catch (error: any) {
    AjaxRequestPublisher.publishCounterMonitor(successMetricSlug, 0);
    logError({
      error,
      loggerMessage: `Failed ${options.method} request to '${sanitizedUrl}'`,
      metricSlug,
    });
    throw error;
  } finally {
    clearTimeout(timeoutId);
    const latency = performance.now() - startTime;
    AjaxRequestPublisher.publishTimerMonitor(`${metricSlug}:latency`, latency);
  }
};

export default fetchRequest;
